import { Navigate } from "react-router-dom";
import { useSession } from "../hooks/useSession";
import { PropsWithChildren } from "react";

export default function ProtectedRoute(props: PropsWithChildren) {
  const { children } = props
  const { isAuthenticated } = useSession();
  return isAuthenticated ? children as any : <Navigate to="/" replace />;
}
